import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_DIRECTION = {
  Horizontally: "horizontally",
  Vertically: "vertically",
} as const;

export type DSDirection = ObjectValues<typeof DS_DIRECTION>;
